import PRM from "@/core/PermissionConstants";

export default {
    path: "/app/revalidacion/historial",
    name: "REVALIDATION-HISTORY",
    component: () => import("@/app/views/InterpretationView.vue"),
     beforeEnter: (to, from, next) => {
    const { autoOpenId, autoOpenType } = to.query || {};

    if (!autoOpenId || !autoOpenType) {
      return next({ name: "INTERPRETATION-HISTORY" });
    }

    next();
  },
    meta: {
        service: () => import("@/app/services/InterpretationHistoryService"),
        table: () => import("@/app/components/interpretation/revalidationHistory/InterpretationRevalidationHistoryTable.vue"),
        form: () => import("@/app/components/interpretation/revalidationHistory/InterpretationRevalidationHistoryForm.vue"),
        addenumViewer: () => import("@/app/components/interpretation/revalidationHistory/interpretationAddenumViewer.vue"),
        serviceDialog: () => import("@/app/services/TemplateDialogService"),
        tableDialog: () => import("@/app/components/dialog/templateDialog/TemplateDialogTable.vue"),
        formDialog: () => import("@/app/components/dialog/templateDialog/TemplateDialogForm.vue"),
      header: {
        icono: "mdi-clipboard-text-outline",
        texto: "Historial de interpretación",
        textNew: "",
        textEdit: "Editar interpretación",
      },
      headerDialog: {
        icono: "mdi-wrench",
        texto: "Plantilla",
        textNew: "Nueva plantilla",
        textEdit: "Editar plantilla",
      },
      prm: PRM.MODULE_IMAGE_INTERPRETATION_HISTORY,
      requireAuth: true,
      filterDate: true,
      hideButtonAdd: true,
      addButtonText: "GUARDAR INTERPRETACIÓN",
      filterModality: true,
      cancelationModal: true,
      generatePDFModal: true,
      history: true,
      addenumViewerFlag: true,
      hideButtonAddDialog: false,
      addButtonTextDialog: "AGREGAR PLANTILLA",      
    },
  };
  